export const SUPPORT_EMAIL = 'support@atomyx.io';
export const LINK_TO_MANUAL = 'https://atomyx.notion.site/';
